export default __webpack_public_path__ + "static/media/banner-top-ke.d836a401.webp";